import styled from "styled-components";
import { SIDEBAR_W } from "../../config/layout";

const TOPBAR_H  = "68px";

export const TopBar = styled.header`
  position: fixed;
  top: 0; left: 0; right: 0;
  height: ${TOPBAR_H};
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e0e8f0;
  z-index: 200;
`;

export const TopBarLogo = styled.div`
  width: ${SIDEBAR_W};
  min-width: ${SIDEBAR_W};
  padding: 0 18px;
  display: flex;
  align-items: center;
  height: 100%;
  border-right: 1px solid #e0e8f0;
`;

export const TopBarContent = styled.div`
  flex: 1;
  padding: 0 32px;
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  padding-top: ${TOPBAR_H};
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 28px 32px;
`;

export const PageTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.6rem;
  font-weight: 700;
  margin: 0 0 20px;
`;

/* Fila de dos columnas. Con flex, mientras no exista el panel derecho el chat
   ocupa todo el ancho; al montarlo se estrecha solo, sin tocar el layout. */
export const Columns = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 24px;
  align-items: stretch;

  @media (max-width: 1100px) {
    flex-direction: column;
  }
`;

/* Ambas columnas comparten alto para que terminen a la misma altura */
const COLUMN_HEIGHT = `calc(100vh - ${TOPBAR_H} - 140px)`;

export const ChatColumn = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 420px;
  height: ${COLUMN_HEIGHT};
`;

/* Columna derecha: los detalles del terapeuta y las citas son tarjetas
   independientes, separadas entre sí. */
export const SideColumn = styled.div`
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: ${COLUMN_HEIGHT};
  min-height: 420px;

  @media (max-width: 1100px) {
    width: auto;
    height: auto;
  }
`;

export const SidePanel = styled.aside`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  padding: 22px;
`;

export const SidePanelTitle = styled.h2`
  color: #1b3a6b;
  font-size: 1.05rem;
  font-weight: 700;
  margin: 0 0 14px;
`;

/* ── Therapist Details ── */
export const TherapistRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
`;

export const TherapistAvatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`;

export const TherapistName = styled.span`
  color: #1b2b3a;
  font-size: 0.95rem;
  font-weight: 600;
`;

export const MessageBox = styled.div`
  background: #f1f2f4;
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 0.82rem;
  line-height: 1.5;
  color: #333;
  white-space: pre-wrap;
  word-break: break-word;
`;
